/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetDomainsVariablesDTO = Types.Exact<{
  filter?: Types.Maybe<Types.DomainFilterDTO>;
}>;


export type GetDomainsDTO = (
  { __typename?: 'Query' }
  & { domains: Array<(
    { __typename?: 'Domain' }
    & Pick<Types.DomainDTO, 'id' | 'name'>
  )> }
);


export const GetDomainsDocumentDTO = gql`
    query getDomains($filter: DomainFilter) {
  domains(filter: $filter, sort: [{field: "name", order: ASC}]) {
    id
    name
  }
}
    `;

/**
 * __useGetDomains__
 *
 * To run a query within a React component, call `useGetDomains` and pass it any options that fit your needs.
 * When your component renders, `useGetDomains` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDomains({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDomains(baseOptions?: Apollo.QueryHookOptions<GetDomainsDTO, GetDomainsVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDomainsDTO, GetDomainsVariablesDTO>(GetDomainsDocumentDTO, options);
      }
export function useGetDomainsLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetDomainsDTO, GetDomainsVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDomainsDTO, GetDomainsVariablesDTO>(GetDomainsDocumentDTO, options);
        }
export type GetDomainsHookResult = ReturnType<typeof useGetDomains>;
export type GetDomainsLazyQueryDTOHookResult = ReturnType<typeof useGetDomainsLazyQueryDTO>;
export type GetDomainsQueryResultDTO = Apollo.QueryResult<GetDomainsDTO, GetDomainsVariablesDTO>;